import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Card, Tabs } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import '../../../../styles/pages/warehouse/_mypageWarehouse/index.scss';
import '../../../../styles/abstracts/_variables.scss';
import AccountSetting from '../components/AccountSetting';
import Paypal from '../components/Paypal';
import moment from 'moment';
import { formatDateTime } from '@root/utils/helpers/formatDate';

const breadcrumbList = [
  {
    tittle: 'My Account',
    url: ''
  }
];

const HomeWarehouse = () => {
  const [date, setDate] = useState('');

  return (
    <>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />

      <div className="admin-container ">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '100vh',
            background: 'none'
          }}
        >
          <div className="wrapMyPageWarehouse">
            <div className="dateMember">
              <p>Date of membership {formatDateTime(date)}</p>
            </div>{' '}
            <div className="wrapTabWare">
              <Tabs defaultActiveKey="1">
                <Tabs.TabPane tab="Account Settings" key="1">
                  <AccountSetting setDate={setDate} />
                </Tabs.TabPane>

                <Tabs.TabPane tab="Paypal account information" key="2">
                  <Paypal />
                </Tabs.TabPane>
              </Tabs>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
};

export default HomeWarehouse;
